import React, { ReactElement } from 'react';
import { ErrorComponent } from './error-component';
import { Skeleton } from './skeleton';

export type SkeletonLoaderStatus =
  | 'loading'
  | 'error'
  | 'success'
  | 'idle'
  | 'pending';

export interface SkeletonLoaderProps {
  status: SkeletonLoaderStatus | SkeletonLoaderStatus[];
  children?: React.ReactNode;
  error?: unknown;
  errorRender?: React.ReactElement<any>;
  repeat?: number;
  type?: 'normal' | 'list' | 'line';
}

export const SkeletonLoader = ({
  status,
  children,
  error,
  errorRender,
  repeat = 1,
  type = 'normal',
}: SkeletonLoaderProps): ReactElement<any> => {
  let effectiveStatus: SkeletonLoaderStatus = 'loading';
  if (Array.isArray(status)) {
    if (status.includes('error')) {
      effectiveStatus = 'error';
    } else if (status.every((s) => s === 'success')) {
      effectiveStatus = 'success';
    }
  } else {
    effectiveStatus = status;
  }
  // Pending is the new value in @tanstack/react-query@5 synonymous to 'loading'
  if (effectiveStatus === 'pending') {
    effectiveStatus = 'loading';
  }

  switch (effectiveStatus) {
    case 'success':
      return <>{children}</>;
    case 'error':
      return errorRender ? errorRender : <ErrorComponent error={error} />;
    default:
      return (
        <div className="flex-shrink-0 animate-pulse">
          <Skeleton repeat={repeat} type={type} />
        </div>
      );
  }
};
